import React, { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'

const IconButton = ({
  className = '',
  disabled,
  ghost,
  icon,
  iconStyle,
  loading = false,
  size,
  style,
  text = '',
  textStyle,
  type,
  onClick,
  ...buttonProps
}) => {
  const localText = useMemo(
    () => (text.length > 0 ? (<span style={textStyle}> &nbsp; {text} </span>) : text),
    [text, textStyle]
  )

  return (
    <Button
      className={className}
      disabled={disabled ?? false}
      loading={loading}
      size={size ?? 'default'}
      type={type ?? 'default'}
      ghost={ghost}
      onClick={onClick}
      style={style}
      {...buttonProps}
    >
      <FontAwesomeIcon icon={icon} style={iconStyle} />
      {localText}
    </Button>
  )
}

export default IconButton
